<template>
  <div class="card template-container">
    <base-loader v-if="isLoading && !templates.length" />

    <div class="template-wrapper" v-else>
      <BaseActionHeader spacing="wide" title-tag="div">
        <template #title>
          <div>
          <h3 class="header-title">Документы</h3>
          <p class="header-subtitle">
            Печатные формы и шаблоны документов по этому заказу
          </p>
          </div>
        </template>
        <base-button @click="goToTemplates()">
          Настройки шаблонов
        </base-button>
      </BaseActionHeader>

      <ul class="template-list" v-if="filteredTemplates.length > 0">
        <li
          class="template-item"
          v-for="template in filteredTemplates"
          :key="template.id"
          @click="goToTemplateDetails(template.id)"
        >
          <div class="item-info">
            <h4 class="item-name">
              {{ template.name }}
            </h4>
            <p class="item-desc" v-if="template.description">
              {{ template.description }}
            </p>
          </div>
          <base-button
            class="btn"
            @click.stop="
              renderTemplate(template.id, {
                record_id: targetId,
                record_type: 'Order',
              })
            "
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              style="vertical-align: middle; margin-right: 5px"
            >
              <polyline points="6 9 6 2 18 2 18 9" />
              <path
                d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"
              />
              <rect x="6" y="14" width="12" height="8" />
            </svg>
            Напечатать
          </base-button>
        </li>
      </ul>

      <div v-else class="no-data">Список шаблонов пуст</div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "pinia";

import { useTemplateStore } from "@/stores/templateStore";

export default {
  name: "TemplateList",
  components: {},
  props: {
    targetId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      selectedTemplate: null,
    };
  },
  computed: {
    ...mapState(useTemplateStore, ["templates", "isLoading"]),

    filteredTemplates() {
      return this.templates.filter(
        (t) => t.kind !== "order_invoice" && t.enabled
      );
    },
  },

  methods: {
    ...mapActions(useTemplateStore, [
      "getTemplatesRequest",
      "renderTemplate",
    ]),

    goToTemplates() {
      this.$router.push({
        name: "Templates",
      });
    },

    goToTemplateDetails(templateId) {
      this.$router.push({
        name: "TemplateDetails",
        params: { id: templateId },
      });
    },
  },

  async created() {
    await this.getTemplatesRequest();
  },
};
</script>

<style scoped>
.header-subtitle {
  margin: 4px 0 0;
  color: #6b7280;
  font-size: 13px;
}

.template-list {
  display: flex;
  flex-direction: column;
  gap: var(--base-in-indent);
}

.template-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  gap: 15px;
  padding: 16px;
  background: rgb(240, 240, 240);
  border-radius: 8px;
  transition: all 0.3s ease;
  cursor: pointer;
}

.template-item:hover {
  background: #e6f5ed;
  transform: translateX(4px);
}

.item-info {
  display: flex;
  flex-direction: column;
  gap: 7px;
}

.item-name {
  font-weight: 600;
}

.item-desc {
  width: 70%;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.2;
  color: #666;
}

.btn {
  flex-shrink: 0;
}

@media (max-width: 768px) {
  .template-item {
    flex-direction: column;
    gap: 10px;
    align-items: flex-start;
  }

  .item-desc {
    max-width: 100%;
  }
}
</style>
